import { render, staticRenderFns } from "./PgFeeSettingsModal.vue?vue&type=template&id=79d17bab&scoped=true&lang=pug"
import script from "./PgFeeSettingsModal.vue?vue&type=script&lang=ts"
export * from "./PgFeeSettingsModal.vue?vue&type=script&lang=ts"
import style0 from "./PgFeeSettingsModal.vue?vue&type=style&index=0&id=79d17bab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d17bab",
  null
  
)

export default component.exports